export default __webpack_public_path__ + "static/media/604.4669c208.gif";